const houseParts = require('../house-parts');
const byoThemeElements = require('../byo-theme-elements');
const channels = require('../channels');
const types = require('../types');
const themeGroups = require('../theme-groups');
const themes = require('../themes');
const elementGroups = require('../element-groups');

module.exports = {
  TREE_MULTI: {
    id: 'TREE_MULTI',
    name: 'Tree Party',
    animation: 'OFF',
    type: types.Multi,
    housePart: houseParts.TREE.id,
    byoThemeElementId: byoThemeElements.INSIDE_TREE.id,
    availableInThemes: [...themeGroups.MULTI],
    groups: [elementGroups.INSIDE, elementGroups.TREES],
    brightness: { [channels.CONST__CH_1]: 0, [channels.CONST__CH_2]: 0 }
  },

  TREE_COOL_WHITE: {
    id: 'TREE_COOL_WHITE',
    name: 'Tree Ice',
    animation: 'OFF',
    type: types.CoolWhite,
    housePart: houseParts.TREE.id,
    byoThemeElementId: byoThemeElements.INSIDE_TREE.id,
    availableInThemes: [...themeGroups.COOL_WHITE],
    groups: [elementGroups.INSIDE, elementGroups.TREES],
    brightness: { [channels.CONST__CH_1]: 0, [channels.CONST__CH_2]: 0 }
  },

  TREE_WARM_WHITE: {
    id: 'TREE_WARM_WHITE',
    name: 'Tree Classic',
    animation: 'OFF',
    type: types.WarmWhite,
    housePart: houseParts.TREE.id,
    byoThemeElementId: byoThemeElements.INSIDE_TREE.id,
    availableInThemes: [...themeGroups.WARM_WHITE],
    groups: [elementGroups.INSIDE, elementGroups.TREES],
    brightness: { [channels.CONST__CH_1]: 0, [channels.CONST__CH_2]: 0 }
  },

  MEGA_TREE_MULTI: {
    id: 'MEGA_TREE_MULTI',
    name: 'Mega Tree Party',
    animation: 'OFF',
    type: types.Multi,
    housePart: houseParts.GARDEN.id,
    byoThemeElementId: byoThemeElements.MEGA_TREE.id,
    availableInThemes: [...themeGroups.MULTI],
    groups: [elementGroups.TREES],
    brightness: { [channels.CONST__CH_1]: 0, [channels.CONST__CH_2]: 0 }
  },

  MEGA_TREE_COOL_WHITE: {
    id: 'MEGA_TREE_COOL_WHITE',
    name: 'Mega Tree Ice',
    animation: 'OFF',
    type: types.CoolWhite,
    housePart: houseParts.GARDEN.id,
    byoThemeElementId: byoThemeElements.MEGA_TREE.id,
    availableInThemes: [...themeGroups.COOL_WHITE],
    groups: [elementGroups.TREES],
    brightness: { [channels.CONST__CH_1]: 0, [channels.CONST__CH_2]: 0 }
  },

  MEGA_TREE_WARM_WHITE: {
    id: 'MEGA_TREE_WARM_WHITE',
    name: 'Mega Tree Classic',
    animation: 'OFF',
    type: types.WarmWhite,
    housePart: houseParts.GARDEN.id,
    byoThemeElementId: byoThemeElements.MEGA_TREE.id,
    availableInThemes: [...themeGroups.WARM_WHITE],
    groups: [elementGroups.TREES],
    brightness: { [channels.CONST__CH_1]: 0, [channels.CONST__CH_2]: 0 }
  },

  MEGA_TREE_STAR_MULTI: {
    id: 'MEGA_TREE_STAR_MULTI',
    name: 'Roof Tree Multi Star',
    animation: 'OFF',
    type: types.WarmWhite,
    housePart: houseParts.GARDEN.id,
    byoThemeElementId: byoThemeElements.MEGA_TREE_STAR.id,
    availableInThemes: [...themeGroups.MULTI],
    groups: [elementGroups.GARDEN, elementGroups.MEGA_TREE],
    brightness: { [channels.CONST__CH_1]: 0, [channels.CONST__CH_2]: 0 }
  },

  MEGA_TREE_STAR_COOL: {
    id: 'MEGA_TREE_STAR_COOL',
    name: 'Roof Tree White Star',
    animation: 'OFF',
    type: types.CoolWhite,
    housePart: houseParts.GARDEN.id,
    byoThemeElementId: byoThemeElements.MEGA_TREE_STAR.id,
    availableInThemes: [...themeGroups.COOL_WHITE],
    groups: [elementGroups.GARDEN, elementGroups.MEGA_TREE],
    brightness: { [channels.CONST__CH_1]: 0, [channels.CONST__CH_2]: 0 }
  },

  MEGA_TREE_STAR_WARM: {
    id: 'MEGA_TREE_STAR_WARM',
    name: 'Roof Tree Warm White Star',
    animation: 'OFF',
    type: types.Blue,
    housePart: houseParts.GARDEN.id,
    byoThemeElementId: byoThemeElements.MEGA_TREE_STAR.id,
    availableInThemes: [...themeGroups.WARM_WHITE],
    groups: [elementGroups.GARDEN, elementGroups.MEGA_TREE],
    brightness: { [channels.CONST__CH_1]: 0, [channels.CONST__CH_2]: 0 }
  },

  // SMALL_TREE: {
  //   id: 'SMALL_TREE',
  //   name: 'Small Tree (Custom lights)',
  //   animation: 'OFF',
  //   type: types.Multi,
  //   housePart: houseParts.FENCE.id,
  //   byoThemeElementId: byoThemeElements.SMALL_TREE.id,
  //   availableInThemes: [...themeGroups.MULTI],
  //   groups: [elementGroups.FENCE, elementGroups.TREES],
  //   brightness: { [channels.CONST__CH_1]: 0, [channels.CONST__CH_2]: 0 }
  // }
};
